module.exports = "/* ---------------------------------------------------\n    CONTENT STYLE\n----------------------------------------------------- */\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/iglesias/iglesias.component.css
// module id = ./src/app/admin/pages/iglesias/iglesias.component.css
// module chunks = main